import __request__ from "routing/request";
export function functions(requestOptions) {
  return __request__("GET", "/views/functions", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
